module.exports = __webpack_public_path__ + "static/media/qrcode.fbc238ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/qrcode.png
// module id = 140
// module chunks = 15